<template lang="pug">
  .header-separator
    div(v-for="(color, index) in separatorColors" class="separator" :style="{ 'background-color': color }" :key="index")

</template>

<script>
import { separatorColors } from '@/utils/add-styles-in-header.js'

export default {
  data: () => ({
    separatorColors
  })
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/variables'

.header-separator
  width: 100%
  display: block
  line-height: 0

.separator
  display: inline-block
  width: "calc((100vmax - %s) / 10)" % $scroll-size
  width: "calc((100vw - %s) / 10)" % $scroll-size
  height: $line-multicolor-header-separator-height

</style>
